import { PolygonMarkerEdge } from './PolygonMarkerEdge'
import { PolygonMarkerVertexHandle } from './PolygonMarkerHandle'
import type { Point } from '../../types'

class PolygonMarkerVertex {
  x: number
  y: number
  edges: Array<PolygonMarkerEdge>
  handle: PolygonMarkerVertexHandle

  constructor(x: number, y: number) {
    this.x = x
    this.y = y
    this.edges = [] // Edges connecting this vertex to other vertices
    this.handle = null // Handle that control this vertex
  }

  move(deltaX: number, deltaY: number) {
    this.x += deltaX
    this.y += deltaY
  }

  appendEdge(edge: PolygonMarkerEdge) {
    this.edges.push(edge)
  }

  get position(): Point {
    return {
      x: this.x,
      y: this.y,
    }
  }

  set position(point: Point) {
    this.x = point.x
    this.y = point.y
  }
}

export { PolygonMarkerVertex }
